// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-4-custom[data-v-23a25806] {\n  margin-bottom: 1.4rem !important;\n  margin-top: 1.4rem !important;\n}\n.fs-22[data-v-23a25806] {\n  font-size: 22px !important;\n}\n.fs-40[data-v-23a25806] {\n  font-size: 40px !important;\n}\n.text-gray-7[data-v-23a25806] {\n  color: #3F5B60;\n}\n[data-v-23a25806] .custom-input__extended .input-group .input-group-text {\n  background: #2DB782;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
